import { createFileRoute } from '@tanstack/react-router'

import { SignupForm } from '@/features/auth/signup-form'

export const Route = createFileRoute('/signup')({
  component: () => (
    <section className="p-6">
      <h1 className="mb-4 text-2xl">Rejestracja</h1>
      <SignupForm />
    </section>
  ),
})
